// extracted by mini-css-extract-plugin
export default {"cls1":"flkafaqz48uEe210Gmzl","cls2":"I9FmTIfyzqmiLMQ4pIUU flkafaqz48uEe210Gmzl"};